module.exports = __webpack_public_path__ + "static/img/2306_phase_function_Paper_Points.ffa5857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2306_phase_function_Paper_Points.png
// module id = m65i
// module chunks = 0